import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="footer-logo-monogram">II</span>
              <span className="footer-logo-name">Deal Israel</span>
            </div>
            <p className="footer-tagline">Les meilleurs deals immobiliers en Israël — prix, rendements et opportunités pour les investisseurs francophones.</p>
            <div className="footer-contact">
              <a href="mailto:contact@deal-israel.com" className="footer-contact-link">contact@deal-israel.com</a>
            </div>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">Navigation</h4>
            <nav className="footer-nav">
              <Link to="/">Accueil</Link>
              <Link to="/villes">Villes d'Israël</Link>
              <Link to="/simulateurs">Simulateurs</Link>
              <Link to="/strategies">Stratégies</Link>
              <Link to="/accompagnement">Accompagnement</Link>
            </nav>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">Villes phares</h4>
            <nav className="footer-nav">
              {['tel-aviv','jerusalem','haifa','netanya','beer-sheva','eilat'].map(s => (
                <Link key={s} to={`/villes/${s}`}>{s.replace('-',' ').replace(/\b\w/g, c => c.toUpperCase())}</Link>
              ))}
            </nav>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">Ressources</h4>
            <nav className="footer-nav">
              <Link to="/calculateur-net">Calculateur net</Link>
              <Link to="/blog">Guide & Articles</Link>
              <Link to="/glossaire">Glossaire</Link>
              <Link to="/mentions-legales">Mentions légales</Link>
            </nav>
          </div>
        </div>
        <div className="footer-disclaimer">
          <p>Les données présentées sont indicatives et ne constituent pas un conseil en investissement. Consultez un professionnel qualifié avant toute décision d'acquisition.</p>
        </div>
        <div className="footer-bottom">
          <span>© 2025 Deal Israel — Tous droits réservés</span>
          <Link to="/mentions-legales" style={{ color: 'rgba(250,250,248,0.45)', fontSize: '0.75rem', textDecoration: 'none', marginLeft: '1.5rem' }}>Mentions légales</Link>
        </div>
      </div>
    </footer>
  );
}
